import React, { ReactElement, useEffect, useState } from 'react';
import { isEmpty } from 'underscore';
import { getAddressFromLatLongAsync } from '../../../core/utils/api';
import { Building, Location } from '@carbon/icons-react';

interface AddressFetcherProps {
    lat: string | number;
    lng: string | number;
    key?: React.Key;
    onLocationFetched?: (address: string) => void;
    useAlternativeIcon?: boolean;
}

const AddressFetcher: React.FC<AddressFetcherProps> = ({
    lat,
    lng,
    key = null,
    onLocationFetched = () => {},
    useAlternativeIcon = false,
}) => {
    const [address, setAddress] = useState<string | null>(null);
    const [hasErrored, setHasErrored] = useState<boolean>(false);
    const icon = useAlternativeIcon ? (
         <Building
            size={12}
            color='var(--cool-gray-60)'
        />
    ) : (
       <Location 
            size={12}
            color='var(--cool-gray-60)'
        />
    );
    const emptyValuePlaceholder = (
        <>
            {icon}
            &ensp;
            -
        </>
    );
    let content: ReactElement | null = null;
    if (!lat && !lng) {
        content = (<div>{emptyValuePlaceholder}</div>);
    } else if (address && address !== '""') {
        content = (<div>{icon}&ensp;{address?.replace(/"/g, '') || ''}</div>);
    } else if (hasErrored) {
        content = (<div>{icon}</div>);
    } else if (address === null) {
        content = (
            <div>
                {icon}
                &ensp;
                Loading...
            </div>
        );
    } else {
        content = (<div>{emptyValuePlaceholder}</div>);
    }

    useEffect(() => {
        if (lat && lng) {
            getAddressFromLatLongAsync(lat, lng, (error: any, data: any) => {
                if (error) {
                    setHasErrored(true);
                } else {
                    let address = data;
                    if (!address) {
                        address = '-';
                    }
                    address = address.replace(/"/g, '');
                    setAddress(address);
                    if (onLocationFetched) {
                        onLocationFetched(address);
                    }
                }
            });
        } else {
            setHasErrored(true);
        }
    }, [lat, lng])
    
    return (
        <div key={key}>
            {content}
        </div>
    );
}

export default AddressFetcher;
